module.exports = __webpack_public_path__ + "img/1_disponibilidad.52b7b4cb.svg";